/* Central content + imagery for the site.
   Images use Unsplash source URLs so the site renders fully without local
   assets. Replace `img` values with local imports from src/assets/ anytime. */

export const CONTACT = {
  phone: '+91 93424 42639',
  phoneHref: 'tel:+919342442639',
  phone2: '+91 63852 16583',
  phone2Href: 'tel:+916385216583',
  whatsapp: '919342442639',
  email: 'magizhorganicfarm@gmail.com',
  address: 'Mahizh Natural Farm, Arumbavur, Perambalur District, Tamil Nadu, India',
  // Exact farm location
  lat: 11.369020,
  lng: 78.736003,
};

export const PRODUCTS = [
  {
    name: 'Organic Vegetables',
    desc: 'Seasonal, hand-picked vegetables grown in living soil — free from pesticides.',
    img: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&w=800&q=70',
  },
  {
    name: 'Fresh Fruits',
    desc: 'Sun-ripened bananas, mangoes and native fruits harvested at peak sweetness.',
    img: 'https://images.unsplash.com/photo-1619566636858-adf3ef46400b?auto=format&fit=crop&w=800&q=70',
  },
  {
    name: 'Traditional Rice',
    desc: 'Heritage paddy varieties cultivated the way our ancestors intended.',
    img: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?auto=format&fit=crop&w=800&q=70',
  },
  {
    name: 'Millets',
    desc: 'Nutrient-dense siruthaniyam — foxtail, little and kodo millets.',
    img: 'https://images.unsplash.com/photo-1615485290382-441e4d049cb5?auto=format&fit=crop&w=800&q=70',
  },
  {
    name: 'Cold Pressed Oils',
    desc: 'Wood-pressed (marachekku) oils retaining natural aroma and nutrients.',
    img: 'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?auto=format&fit=crop&w=800&q=70',
  },
  {
    name: 'Native Seeds',
    desc: 'Open-pollinated heirloom seeds preserving our agricultural heritage.',
    img: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=800&q=70',
  },
  {
    name: 'Organic Fertilizers',
    desc: 'Farm-made compost and panchagavya that nourish soil, not deplete it.',
    img: 'https://images.unsplash.com/photo-1592982537447-7440770cbfc9?auto=format&fit=crop&w=800&q=70',
  },
  {
    name: 'Herbal Products',
    desc: 'Traditional herbs and remedies grown and prepared naturally on the farm.',
    img: 'https://images.unsplash.com/photo-1611071536600-6f5d6d5f0e0f?auto=format&fit=crop&w=800&q=70',
  },
];

export const GALLERY = [
  {
    title: 'Our Farm',
    category: 'Farm',
    img: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=800&q=70',
  },
  {
    title: 'Green Crops',
    category: 'Crops',
    img: 'https://images.unsplash.com/photo-1523348837708-15d4a09cfac2?auto=format&fit=crop&w=800&q=70',
  },
  {
    title: 'Fresh Harvest',
    category: 'Harvest',
    img: 'https://images.unsplash.com/photo-1464226184884-fa280b87c399?auto=format&fit=crop&w=800&q=70',
  },
  {
    title: 'Banana Plantation',
    category: 'Banana Plantation',
    img: 'https://images.unsplash.com/photo-1603052875302-d376b7c0638a?auto=format&fit=crop&w=800&q=70',
  },
  {
    title: 'Coconut Trees',
    category: 'Coconut Trees',
    img: 'https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=800&q=70',
  },
  {
    title: 'Garden Vegetables',
    category: 'Vegetables',
    img: 'https://images.unsplash.com/photo-1518977676601-b53f82aba655?auto=format&fit=crop&w=800&q=70',
  },
  {
    title: 'Ripe Fruits',
    category: 'Fruits',
    img: 'https://images.unsplash.com/photo-1610832958506-aa56368176cf?auto=format&fit=crop&w=800&q=70',
  },
  {
    title: 'Farm Landscape',
    category: 'Landscape',
    img: 'https://images.unsplash.com/photo-1444858291040-58f756a3bdd6?auto=format&fit=crop&w=800&q=70',
  },
];

export const TESTIMONIALS = [
  {
    name: 'Lakshmi Narayanan',
    location: 'Chennai, Tamil Nadu',
    rating: 5,
    review:
      'The vegetables taste exactly like the ones from my grandmother\'s village. Fresh, clean and full of flavour. Mahizh has changed how my family eats.',
    photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=70',
  },
  {
    name: 'Karthik Raja',
    location: 'Coimbatore, Tamil Nadu',
    rating: 5,
    review:
      'Their cold pressed oils and traditional rice are unmatched. You can feel the care of natural farming in every product. Highly recommended.',
    photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=70',
  },
  {
    name: 'Priya Venkatesh',
    location: 'Madurai, Tamil Nadu',
    rating: 5,
    review:
      'I trust Mahizh completely for my children. Truly chemical-free, delivered fresh, and the team genuinely cares about sustainable farming.',
    photo: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=200&q=70',
  },
];
